<script setup>
import { useI18n } from "vue-i18n";
import { languages } from "@/enums/enums.js";
import { computed } from "vue";

const { locale, t } = useI18n();

function changeLanguage(lang) {
    locale.value = lang;
    localStorage.setItem("locale", lang);
}

const currentLang = computed(() => {
    return languages.find((l) => l.code === locale.value);
});
</script>

<template>
    <v-menu>
        <template v-slot:activator="{ props }">
            <button
                class="language-menu-btn border-none rounded-circle position-relative"
                v-bind="props"
            >
                <v-img
                    class="me-2"
                    :src="currentLang?.flag"
                    :alt="currentLang?.alt"
                />
            </button>
        </template>

        <v-list class="language-menu-dropdown">
            <span class="title fw-semibold text-black d-block">
                {{ t("common.labels.chooseLanguage") }}
            </span>
            <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
                <li v-for="lang in languages" :key="lang.code">
                    <button
                        type="button"
                        class="d-flex align-items-center border-none"
                        @click="changeLanguage(lang.code)"
                    >
                        <v-img :src="lang.flag" :alt="lang.alt" />
                        {{ lang.label }}
                    </button>
                </li>
            </ul>
        </v-list>
    </v-menu>
</template>
